import { createFileRoute } from '@tanstack/react-router';
import { routeContracts } from '@/app/router/routeContracts';

export const Route = createFileRoute('/columbus-planner')({
  component: routeContracts.columbusPlan.component,
});
